import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from '../locales/en/smb.json';
import noTranslations from '../locales/no/smb.json';

/**
 * Copy for the site at /smb. A separate instance so those pages keep their own strings
 * while the groups page at / uses the default catalog.
 */
const smbI18n = i18n.createInstance();

const ready = smbI18n.use(initReactI18next).init({
  lng: 'no',
  fallbackLng: 'no',
  supportedLngs: ['en', 'no'],
  resources: {
    en: {
      translation: enTranslations,
    },
    no: {
      translation: noTranslations,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export { ready };
export default smbI18n;
